export default "__VITE_ASSET__CNMDtJNI__"